import React, { Fragment, Component } from 'react';
import gtmParts from 'react-google-tag-manager';

class GoogleTagManager extends Component {
  componentDidMount() {
    const scriptId = this.props.scriptId || 'react-google-tag-manager-gtm';
    const gtmAdded = document.getElementById('gtmAdded');

    if (!gtmAdded && document) {
      const script = document.createElement('script');
      const gtmScriptNode = document.getElementById(scriptId);
      let scriptText;
      if (gtmScriptNode) {
        const elem = document.createElement('div');
        elem.setAttribute('id', 'gtmAdded');
        document.body.appendChild(elem);
        scriptText = document.createTextNode(gtmScriptNode.textContent);
        script.appendChild(scriptText);
        document.head.appendChild(script);
      }
    }
  }

  render() {
    const gtm = gtmParts({
      id: this.props.gtmId,
      dataLayerName: this.props.dataLayerName || 'dataLayer',
      additionalEvents: this.props.additionalEvents || {},
      previewVariables: this.props.previewVariables || false,
    });
    return (
      <Fragment>
        {gtm.noScriptAsReact()}
        <div id={this.props.scriptId || 'react-google-tag-manager-gtm'}>
          {gtm.scriptAsReact()}
        </div>
      </Fragment>
    );
  }
}

export default GoogleTagManager;
